"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _standardTail = _interopRequireDefault(require("./hotspot-designs/standardTail"));

var _hotspot = require("./hotspot.constants");

var _hotspot2 = _interopRequireDefault(require("./hotspot.import"));

var _hotspot3 = require("./hotspot.styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Hotspot = function Hotspot(_ref) {
  var config = _ref.config,
      containerStyles = _ref.containerStyles,
      currentSecond = _ref.currentSecond,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? {
    left: 0,
    top: 0
  } : _ref$iconPosition,
      inSeconds = _ref.inSeconds,
      name = _ref.name,
      onClick = _ref.onClick,
      outSeconds = _ref.outSeconds,
      playing = _ref.playing,
      previewHoverState = _ref.previewHoverState,
      tag = _ref.tag,
      tagText = _ref.tagText,
      disableHover = _ref.disableHover,
      hideAnchor = _ref.hideAnchor,
      customPlayer = _ref.customPlayer;

  if (!tag) {
    return null;
  }

  var id = tag.id;

  if (config && config.presetId) {
    id = config.presetId;
  }

  if (!_hotspot2.default[id]) {
    if (tag.icon) {
      return _react.default.createElement("img", {
        src: tag.icon,
        alt: tag.name
      });
    }

    return null;
  }

  var HotspotComponent = _hotspot2.default[id];
  var progressPercentage = (currentSecond - inSeconds) / (outSeconds - inSeconds - _hotspot.FADE_TIME) * 100;
  var shouldFadeOut = currentSecond > outSeconds - _hotspot.FADE_TIME;

  if (id === _hotspot.standardTailId) {
    return _react.default.createElement(_standardTail.default, {
      config: config,
      containerStyles: containerStyles,
      iconPosition: iconPosition,
      name: tagText || name,
      onClick: onClick,
      playing: playing,
      progressPercentage: progressPercentage,
      previewHoverState: previewHoverState,
      shouldFadeOut: shouldFadeOut,
      tag: tag,
      hideAnchor: hideAnchor,
      customPlayer: customPlayer
    });
  }

  return _react.default.createElement(_hotspot3.HotspotWrapper, {
    containerStyles: containerStyles,
    playing: playing,
    shouldFadeOut: shouldFadeOut,
    customPlayer: customPlayer
  }, _react.default.createElement(HotspotComponent, {
    config: config,
    iconPosition: iconPosition || {},
    name: tagText || name,
    onClick: onClick,
    progressPercentage: progressPercentage,
    previewHoverState: previewHoverState,
    tag: tag,
    disableHover: disableHover
  }));
};

var _default = Hotspot;
exports.default = _default;